import { useEffect, useRef, useState } from 'react';
import logo from '../assets/logo.png';

/* Fixed topbar — goes solid past the hero, hides on scroll down, returns on scroll up. */
export default function TopBar({ onBack, onShare }) {
  const [solid, setSolid] = useState(false);
  const [hidden, setHidden] = useState(false);
  const acc = useRef({ lastY: 0, up: 0, down: 0 });

  useEffect(() => {
    acc.current.lastY = window.scrollY;
    const onScroll = () => {
      const a = acc.current;
      const y = Math.max(0, window.scrollY), d = y - a.lastY;
      setSolid(y > 250);
      if (d > 0) { a.down += d; a.up = 0; if (a.down > 14 && y > 140) setHidden(true); }
      else if (d < 0) { a.up -= d; a.down = 0; if (a.up > 2) setHidden(false); }
      if (y < 80) setHidden(false);
      a.lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={'gfg-topbar' + (solid ? ' gfg-solid' : '') + (hidden ? ' gfg-hidden' : '')}>
      <div className="gfg-bar-actions">
        <button className="gfg-iconbtn" onClick={onShare} aria-label="Share">
          <svg viewBox="0 0 24 24"><path d="M18 16.1c-.8 0-1.5.3-2 .8l-7.1-4.2c.1-.2.1-.5.1-.7s0-.5-.1-.7L16 7.2c.5.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .2 0 .5.1.7L8 9.9c-.5-.5-1.2-.9-2-.9-1.7 0-3 1.3-3 3s1.3 3 3 3c.8 0 1.5-.3 2-.8l7.1 4.2c0 .2-.1.4-.1.6 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9-1.2-2.9-2.8-2.9z" /></svg>
        </button>
      </div>
    </div>
  );
}
